export const normalizeDate = (value: string): string => {
  const [date, month, year] = value.split("-");
  return `${year}-${month}-${date}`;
};
